/**
 * Private modules
 */
const {
  compositeKey,
  createQueryComponent,
  customerId,
  customerSystemTicketNumberPluginId,
  model,
  multiplier,
  number,
  systemGameId,
  systemGamePrizeId,
} = require('../.private').components;

/**
 * Scopes
 */
const { DEFAULT } = require('../../scopes');

module.exports = {
  deleteCustomerRewardLimitsBySystemGameId: {
    properties: {
      body: {
        properties: {
          models: {
            items: model,
            minItems: 1,
            type: 'array',
            uniqueItems: true,
          },
        },
        required: ['models'],
        type: 'object',
      },
      params: {
        properties: {
          customerId,
          systemGameId,
        },
        required: [
          'customerId',
          'systemGameId',
        ],
        type: 'object',
      },
    },
    required: [
      'body',
      'params',
    ],
    type: 'object',
  },
  getCustomerRewardLimitPackageByCompositeKey: {
    properties: {
      params: {
        properties: {
          compositeKey,
          customerId,
        },
        required: [
          'compositeKey',
          'customerId',
        ],
        type: 'object',
      },
      query: createQueryComponent([DEFAULT]),
    },
    required: [
      'params',
      'query',
    ],
    type: 'object',
  },
  getCustomerRewardLimitsBySystemGameId: {
    properties: {
      params: {
        properties: {
          customerId,
          systemGameId,
        },
        required: [
          'customerId',
          'systemGameId',
        ],
        type: 'object',
      },
      query: createQueryComponent([DEFAULT]),
    },
    required: [
      'params',
      'query',
    ],
    type: 'object',
  },
  saveCustomerRewardLimitsBySystemGameId: {
    properties: {
      body: {
        properties: {
          customerSystemTicketNumberPluginId,
          elements: {
            items: {
              properties: {
                multiplier,
                systemGamePrizeId,
              },
              required: [
                'multiplier',
                'systemGamePrizeId',
              ],
              type: 'object',
            },
            minItems: 1,
            type: 'array',
            uniqueItems: true,
          },
          number,
        },
        required: [
          'customerSystemTicketNumberPluginId',
          'elements',
          'number',
        ],
        type: 'object',
      },
      params: {
        properties: {
          customerId,
          systemGameId,
        },
        required: [
          'customerId',
          'systemGameId',
        ],
        type: 'object',
      },
    },
    required: [
      'body',
      'params',
    ],
    type: 'object',
  },
};
